<template>
    <form id="add-icode-form">
        <AppInput
            v-model="form.serial"
            id="serial"
            class="mb-3"
            :label="$t('Device Serial Number')"
            :disabled="disableSerial"
            placeholder="00000000000"
            :error="form.errors.serial" />

        <div v-for="(code, index) in form.codes" :key="index" class="d-flex justify-content-between pb-2">
            <AppInput
                :id="`collected-${index}`"
                :label="`${$t('Collection Date')}:`"
                class="flex-grow-1"
                :error="form.errors[`codes.${index}.collected` as keyof AddICodeFormType]">
                <AppDatepicker
                    v-model="code.collected"
                    :id="`collected-${index}`"
                    format-model="YYYY-MM-DD"
                    :class="{'is-invalid': form.errors[`codes.${index}.collected` as keyof AddICodeFormType]}"
                    placeholder="ex. 01/01/2024" />
            </AppInput>

            <AppInput
                v-model="code.icode"
                :id="`icode-${index}`"
                class="flex-grow-1 mx-3"
                :label="`${$t('iCode')}:`"
                placeholder="01234567890123456"
                :error="form.errors[`codes.${index}.icode` as keyof AddICodeFormType]" />

            <div class="d-flex align-items-end pb-4">
                <AppButton
                    btn-class="btn-sm"
                    :is-disabled="form.codes.length === 1"
                    @click.prevent="removeCode(index)">
                    <span class="bi bi-dash-circle text-dark"></span>
                </AppButton>
            </div>
        </div>

        <div v-if="form.codes.length < 4" class="d-flex justify-content-center mt-2">
            <AppButton btn-class="btn-light" @click.prevent="addCode">
                <span class="bi bi-plus"></span>
                {{ $t('Add iCode') }}
            </AppButton>
        </div>
    </form>
</template>

<script setup lang="ts">
import { type PropType } from "vue";
import {trans as $t} from "@/vue/composables/missingTranslations";
import { type Form } from "laravel-precognition-vue/dist/types";
import AppInput from "@/vue/shared/v2/AppInput.vue";
import AppDatepicker from "@/vue/shared/AppDatepicker.vue";
import AppButton from "@/vue/shared/AppButton.vue";
import { type AddICodeFormType } from "@/vue/types/forms/addICodeForm";

const props = defineProps({
    form: {
        type: Object as PropType<AddICodeFormType & Form<AddICodeFormType>>,
        required: true,
    },
    disableSerial: {
        type: Boolean,
        required: false,
    },
});

const addCode = () => {
    if (props.form.codes.length === 4) return;

    props.form.codes.push({
        collected: '',
        icode: '',
    });
};
const removeCode = (index: number) => {
    if (props.form.hasErrors) {
        props.form.forgetError(`codes.${index}.collected` as keyof AddICodeFormType);
    }

    props.form.codes.splice(index, 1);
};
</script>
